import { Injectable } from '@angular/core';
import { ApiService } from '../../http/api.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CompanyModel, CommonModuleSave } from '../../models/CompanyModel';

@Injectable({
  providedIn: 'root'
})
export class CompaniesService {

    // Config global de AdminConfiguration.AllowNonCompliantWorkerActivation de la administradora activa
    allowNonCompliantWorkerActivation = false;

    constructor(
        private api: ApiService,
        private _http: HttpClient
    ) { }

    //GET Employers
    getCompanies(){
        return this.api.get('api/Company');
    }

    postCompany(model): Observable<CompanyModel>{
      return this._http.post<CompanyModel>(this.api.getUrl(`api/Company`), model);
    }

    //GET Employer ID
    getCompanyId(id): Observable<CompanyModel>{
        return this._http.get<CompanyModel>(this.api.getUrl(`api/Company/${id}?v3=true`));
    }

    //GET Employer ID
    putCompanyId(companyModel: CommonModuleSave, Id: string ){
        return this._http.put(this.api.getUrl(`api/Company/${Id}`), companyModel);
    }

    //Remplazar informacion condiciones de servicio
    patchCompanyId(Id: string,replace){
      return this._http.patch(this.api.getUrl(`api/Company/${Id}`), replace);
  }

    // Video o imagen de Condiciones de servicio
    updateFileCondicionesDeServicio(id, file) {
        return this._http.put(this.api.getUrl('api/Company/UpdateFileAdStart/'+id), file);
    }

    // Video o imagen de Politicas de privacidad
    updateFilePoliticasDePrivacidad(id, file) {
        return this._http.put(this.api.getUrl('api/Company/UpdatePrivacyPolicies/'+id), file);
    }

    //GET proyect Companu
    getProyectCompany(id): Observable<any>{
        return this._http.get<any>(this.api.getUrl(`api/Project?Company=${id}`));
    }

    // get user admin
    getUsersCompanyIdVinculados(id): Observable<any[]>{
        return this._http.get<any[]>(this.api.getUrl(`api/Company/${id}/AdminUsers`));
    }

    // post user admin
    postUsersCompanyIdVinculados(id, model){
        return this._http.post(this.api.getUrl(`api/Company/${id}/AdminUsers`), model);
    }

    // actualizar img company
    putCompanyUpdateLogo(Id, file) {
        return this._http.put(this.api.getUrl(`api/Company/UpdateLogo/${Id}`), file);
    }

    // actualizar data company
    putCompany(Id, model) {
        return this._http.put(this.api.getUrl(`api/Company/${Id}`), model);
    }

    // get user admin
    getCompanyLimit(adminCompanyInfoId): Observable<any[]>{
        return this._http.get<any[]>(this.api.getUrl(`api/Company/Limit?adminCompanyInfoId=${adminCompanyInfoId}`));
    }

    // actualizar data company
    postCompanyLimit(model) {
        return this._http.post(this.api.getUrl(`api/Company/Limit`), model);
    }


    // Get roles for Company
    getUserByAdminCompany(adminCompanyInfoId): Observable<any[]>{
        return this._http.get<any[]>(this.api.getUrl(`api/Company/UserByAdminCompany?adminCompanyInfoId=${adminCompanyInfoId}`));
    }

    // Get roles for Company
    getRolesCompany(adminCompanyInfoId): Observable<any[]>{
        return this._http.get<any[]>(this.api.getUrl(`api/Company/${adminCompanyInfoId}/Roles`));
    }

    // actualizar data company users
    postRolesCompanyUser(adminCompanyInfoId, model) {
        return this._http.post(this.api.getUrl(`api/Company/UserByAdminCompany/${adminCompanyInfoId}`), model);
    }

    // delete data company users
    deleteRolesCompanyUser(adminCompanyInfoId, userId) {
        return this._http.delete(this.api.getUrl(`api/Company/UserByAdminCompany/${adminCompanyInfoId}/${userId}`));
    }

    // update data schedule
    postScheduleCompany(model) {
      return this._http.post(this.api.getUrl(`api/Company/Schedule`), model);
    }

    // get data schedule
    getScheduleCompany(): Observable<any[]>{
      return this._http.get<any[]>(this.api.getUrl(`api/Company/Schedule`));
    }

    // post payroll news type
    postPayRollNewsType(model) {
      return this._http.post(this.api.getUrl(`api/PayrollNewsType`), model);
    }

    // update payroll news type
    putPayRollNewsType(id, model) {
      return this._http.put(this.api.getUrl(`api/PayrollNewsType/${id}`), model);
    }

    // GET payroll news type
    getPayrollNewsType(): Observable<any[]> {
      const url = this.api.getUrl('api/PayrollNewsType');
      return this._http.get<any[]>(url);
    }

    postFaceRecognition(model) {
      return this._http.post(this.api.getUrl(`api/FaceRecognition`), model);
    }

  getFaceRecognition(adminInfoId): Observable<any[]>{
    return this._http.get<any[]>(this.api.getUrl(`api/FaceRecognition/${adminInfoId}`));
  }

  getDatacheck(adminInfoId): Observable<any[]>{
    return this._http.get<any[]>(this.api.getUrl(`api/Datacheck/admin/settings/${adminInfoId}`));
  }

  postDatacheck(model) {
    return this._http.post(this.api.getUrl(`api/Datacheck/admin/allow`), model);
  }

  // APIS TIPO DE RETIRO ADMINISTRADORA
    /**
     * Permite traer tipos de retiros por admionistradora
     */
    getPersonalTerminationRequestTerminationType(CompanyInfoId?): Observable<any[]> {
        const url = this.api.getUrl(`api/PersonalTerminationRequest/TerminationType${CompanyInfoId !== undefined ? '?CompanyInfoId='+CompanyInfoId: ''}`);
        return this._http.get<any[]>(url);
    }

    /**
     * Permite guardar tipos de retiros por admionistradora
     */
    postTerminationType(model) {
        return this._http.post(this.api.getUrl(`api/PersonalTerminationRequest/TerminationType`), model);
    }

    /**
     * Permite actualizar tipos de retiros por admionistradora
     */
    putTerminationType(positionTypeId, model) {
        return this._http.put(this.api.getUrl(`api/PersonalTerminationRequest/TerminationType/${positionTypeId}`), model);
    }

    /**
     * Permite actualizar los requerimientos por adminsitrador y tipo de retiro
     */
    putRequirementTerminationType(terminationTypeId, model) {
        return this._http.put(this.api.getUrl(`api/PersonalTerminationRequest/TerminationType/Requirement/${terminationTypeId}`), model);
    }

  /**
   * Permite la programación de los informes
   */

  getReportSchedule(): Observable<any[]> {
    return this._http.get<any[]>(this.api.getUrl(`api/ReportSchedule/ReportType`));
  }

  getReportScheduleUserProfile(adminInfoId, reportType, keepId): Observable<any[]> {
    return this._http.get<any[]>(this.api.getUrl(`api/ReportSchedule/Rol?adminInfoId=${adminInfoId}&reportType=${reportType}&keepId=${keepId}`));
  }

  getReportScheduleprogramming(): Observable<any[]> {
    return this._http.get<any[]>(this.api.getUrl(`api/ReportSchedule/ReportScheduleType`));
  }

  getReportScheduleAdminInfo(id): Observable<any[]> {
    return this._http.get<any[]>(this.api.getUrl(`api/ReportSchedule/?adminInfoId=${id}`));
  }

  postReportSchedule(model) {
    return this._http.post(this.api.getUrl(`api/ReportSchedule`), model);
  }

  putReportSchedule(reportScheduleId, model) {
    return this._http.put(this.api.getUrl(`api/ReportSchedule?id=${reportScheduleId}`), model);
  }

  deleteReportSchedule(id) {
    return this._http.delete(this.api.getUrl(`api/ReportSchedule?id=${id}`));
  }

  /**
   * Permite la programación de capacitaciones
   */

  getTraining(): Observable<any[]> {
    return this._http.get<any[]>(this.api.getUrl(`api/Training`));
  }

  getTrainingById(Id): Observable<any[]> {
    return this._http.get<any[]>(this.api.getUrl(`api/Training/${Id}`));
  }

  getRequirementTrainingId(): Observable<any[]> {
    return this._http.get<any[]>(this.api.getUrl(`api/Requirement`));
  }

  getTrainingIdQuestion(trainingId): Observable<any[]> {
    return this._http.get<any[]>(this.api.getUrl(`api/Training/${trainingId}/Questions`));
  }

  postTraining(model) {
    return this._http.post(this.api.getUrl(`api/Training`), model);
  }

  postTrainingQuestionComplete(trainingId: number, formData: FormData): Observable<any> {
    return this._http.post(this.api.getUrl(`api/Training/${trainingId}/Questions/Complete`), formData);
  }

  putTrainingQuestionComplete(questionId: number, formData: FormData): Observable<any> {
    return this._http.put(this.api.getUrl(`api/Training/Questions/${questionId}/Complete`), formData);
  }

  putTraining(model, id) {
    return this._http.put(this.api.getUrl(`api/Training/${id}`), model);
  }

  putTrainingUpdateImage(trainingId, file) {
    return this._http.put(this.api.getUrl(`api/Training/UpdateImage/${trainingId}`), file);
  }

  deleteTrainingQuestion(questionId) {
    return this._http.delete(this.api.getUrl(`api/Training/Questions/${questionId}`));
  }

  doubleTraining(trainingId) {
    return this._http.post(this.api.getUrl(`api/Training/Duplicate/${trainingId}`), {});
  }

  deleteInitialContext(questionId: string) {
    return this._http.delete(this.api.getUrl(`api/Training/Questions/${questionId}/ContextMedia`));
  }

  deleteQuestion(answerId: string) {
    return this._http.delete(this.api.getUrl(`api/Training/Answers/${answerId}/Image`));
  }

  // APIS PARA LA PROGRMACION DE FECHAS EN LOS REQUISITOS
  getRequirementsConfigured(requirementId, adminInfoId): Observable<any[]> {
    return this._http.get<any[]>(this.api.getUrl(`api/Requirement/${requirementId}/Configuration/DurationOptions?adminInfoId=${adminInfoId}`));
  }

  postRequirementsConfigured(requirementId, model) {
    return this._http.post(this.api.getUrl(`api/Requirement/${requirementId}/Configuration/DurationOptions`), model);
  }

  putRequirementsConfigured(optionId, model) {
    return this._http.put(this.api.getUrl(`api/Requirement/Configuration/DurationOptions/${optionId}`), model);
  }

  deleteRequirementsConfigured(optionId) {
    return this._http.delete(this.api.getUrl(`api/Requirement/Configuration/DurationOptions/${optionId}`));
  }

    // APIS Referencias de tipos de horas extras

  getReferencesTypesOvertime(adminInfoId): Observable<any[]> {
    return this._http.get<any[]>(this.api.getUrl(`api/PayrollConfiguration/GetIdentifier/${adminInfoId}`));
  }

  postReferencesTypesOvertime(model) {
    return this._http.post(this.api.getUrl(`api/PayrollConfiguration/Identifier`), model);
  }

  getAdminConfiguration(adminInfoId): Observable<any[]> {
    return this._http.get<any[]>(this.api.getUrl(`api/AdminConfiguration/${adminInfoId}`));
  }

  postAdminConfiguration(model) {
    return this._http.post(this.api.getUrl(`api/AdminConfiguration`), model);
  }

}





